import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Cookie } from "lucide-react";
import { getConsent, setConsent } from "@/lib/consent";

export const ConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(getConsent() === null);
  }, []);

  if (!visible) return null;

  const accept = () => {
    setConsent(true);
    setVisible(false);
  };
  const reject = () => {
    setConsent(false);
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-label="Cookie-Einstellungen"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[100] w-[calc(100%-2rem)] max-w-2xl"
    >
      <Card className="p-4 sm:p-5 shadow-lg border-border bg-card">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <Cookie className="w-6 h-6 text-primary shrink-0 hidden sm:block" aria-hidden />
          <div className="flex-1 text-sm text-muted-foreground">
            Wir verwenden nur technisch notwendige Cookies. Mit Ihrer Einwilligung
            aktivieren wir zusätzlich anonymisierte Statistik (Google Analytics 4)
            zur Verbesserung dieser Seite. Details in unserer{" "}
            <Link to="/datenschutz" className="underline hover:text-primary">
              Datenschutzerklärung
            </Link>
            .
          </div>
          <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
            <Button variant="outline" size="sm" onClick={reject} className="w-full sm:w-auto">
              Nur notwendige
            </Button>
            <Button size="sm" onClick={accept} className="w-full sm:w-auto">
              Statistik erlauben
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};
